import { Injectable } from '@angular/core';
import { Company, ListManufacturersRequest, ListManufacturersResponse, SituViewWebApiClient } from 'situview-webapi-client';
import { ICache } from './theme.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyViewService {
  private readonly fiveMinuteCacheDuration = 5 * 60 * 1000; // 5 minutes in milliseconds
  private readonly thirtyMinuteCacheDuration = 30 * 60 * 1000; // 30 minutes in milliseconds

  constructor(
    private situViewClient: SituViewWebApiClient
  ) {}

  private companiesCache: ICache<Company> | undefined;
  private loadingCompaniesPromise: Promise<Company[]> | null = null;
  LoadCompanies(): Promise<Company[]> {
    if (this.companiesCache && (Date.now() - this.companiesCache.timestamp) < this.thirtyMinuteCacheDuration) {
      return Promise.resolve(this.companiesCache.data);
    } else if (this.loadingCompaniesPromise) {
      return this.loadingCompaniesPromise;
    } else {
      let request = new ListManufacturersRequest();
  
      this.loadingCompaniesPromise = this.situViewClient.listManufacturers(request)
        .then((response: ListManufacturersResponse) => {
          // const sortedCompanies = (response.manufacturers ?? [])
          //   .sort((a, b) => {
          //     const nameA = a.name ?? '';
          //     const nameB = b.name ?? '';
          //     return nameA.localeCompare(nameB);
          //   });
          if (response.success) {
            this.companiesCache = {
              timestamp: Date.now(),
              data: response.manufacturers ?? []
            };
            return this.companiesCache.data;
          } else {
            return [];
          }
        })
        .catch((error: any) => {
          console.error(error);
          throw error; // Rethrow error to be handled by the caller
        })
        .finally(() => {
          this.loadingCompaniesPromise = null;
        });
      return this.loadingCompaniesPromise;
    }
  }

  async getCompanyName(companyId: string | undefined): Promise<string | undefined> {
    if (!companyId) return undefined;
    const companies = await this.LoadCompanies();
    const company = companies.find(c => c.id === companyId);
    return company?.name;
  }

  async getCompanyLogo(companyId: string | undefined): Promise<string | undefined> {
    if (!companyId) return undefined;
    const companies = await this.LoadCompanies();
    const company = companies.find(c => c.id === companyId);
    return company?.logoUrl;
  }
}